import { RefObject } from 'react';

export const scrollPageToBottom = (pageRef: RefObject<HTMLDivElement | null>) => {
  const pageElement = pageRef.current;

  if (!pageElement) {
    return;
  }

  requestAnimationFrame(() => {
    pageElement.scrollTo({
      top: pageElement.scrollHeight,
      behavior: 'smooth',
    });
  });
};
